import React from 'react';
import UserAvatar from "../../Atoms/Templates/UserAvatar";
import Icon from "../../Atoms/Icon";

const NotificationItem = props => {
  const {unread, type} = props
  return (
    <article className={`notification-item cursor-pointer s-pxy-4px s-mb-0 normal-radius hover-change ${unread && 's-bg-blue-50'}`}>
      <div className="s-cross-start nowrap">
        <div className="s-mr-8px">
          {type === 'success' ? (
            <Icon
              size="24px"
              svg="circle-check-fill"
              color="var(--green-accent)"
            />
          ) : type === 'advice' ? (
            <Icon
              size="24px"
              color="var(--blue-accent)"
              svg="information-fill"
            />
          ) : (
            <UserAvatar/>
          )}
        </div>
        <div>
          <p className="small s-mb-0"><span className="s-color-title">Juan Alexis Mora</span> aceptó tu invitación para
            ser parte de Discord</p>
          <p className="s-mb-0 smaller s-color-light-text">Hace 3 horas</p>
        </div>
      </div>

    </article>
  );
};

NotificationItem.propTypes = {};

export default NotificationItem;
